import { Text } from '@/atoms/Text/Text';

export const InfoText = () => {
  return (
    <div className='flex flex-col items-end w-full py-16'>
      <div className='flex'>
        <Text bold dark size='xxl' color='emerald'>
          Connect
        </Text>
        <Text bold size='xxl' color='emerald'>
          ,
        </Text>
      </div>
      <div className='flex'>
        <Text bold dark size='xxl' color='emerald'>
          Curate
        </Text>
        <Text bold size='xxl' color='emerald'>
          ,
        </Text>
      </div>
      <div className='flex gap-1'>
        <Text bold size='xxl' color='emerald'>
          &
        </Text>
        <Text bold dark size='xxl' color='emerald'>
          Converse
        </Text>
      </div>
      <Text bold>with popular apps and trusted</Text>
      <Text bold>websites in one place</Text>
    </div>
  );
};
